import Vue from 'vue'
import SharePop from '@/components/share-pop/share-pop.vue'

// 分享弹窗实例
let shareInstance

// 初始化分享弹窗实例
const initShareInstance = () => {
  const ShareConstructor = Vue.extend(SharePop)
  shareInstance = new ShareConstructor({
    el: document.createElement('div')
  })
  document.body.appendChild(shareInstance.$el)
}

// 全局方法集合
const globalMethods = {
  // 分享方法
  share: {
    show(options = {}) {
      if (!shareInstance) {
        initShareInstance()
      }
      shareInstance.$set(shareInstance, 'shareData', options)
      shareInstance.popupVisible = true
      
    },
    hide() {
      if (shareInstance) {
        shareInstance.popupVisible = false
      }
    }
  },

}

// 注册所有全局方法
export default {
  install(Vue) {
    Object.keys(globalMethods).forEach(key => {
      Vue.prototype[`$${key}`] = globalMethods[key]
    })
  }
}